export default function stateConfig($stateProvider, $urlRouterProvider, $compileProvider, $logProvider) {
  'ngInject';
  $stateProvider.state('webPublicClient', {
    abstract: true,
    template: '<ui-view></ui-view>'
  });

  //Always redirect to the credit request component
  $urlRouterProvider.otherwise('/credit-request');

  // go/generator-webpack-globals
  if ( __PRODUCTION__ ) {
    $compileProvider.debugInfoEnabled(false);
    $logProvider.debugEnabled(false);
  }
};



// WEBPACK FOOTER //
// ./src/app/app.config.js